export default __webpack_public_path__ + "images/cadastrar-usuario-ico.svg";